import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  onModalOpen: () => void;
}

const BottomBar = ({ onModalOpen }: Props) => (
  <div className="powered-by md:flex-row h-10 m-8">
    Gemaakt door de{' '}
    <a href="https://thuisleefgroep.nl" className="underline" target="_blank" rel="noopener noreferrer">
      Thuisleefgroep
    </a>{' '}
    &copy; {new Date().getFullYear()} -{' '}
    <Link className="underline" to="#" onClick={() => onModalOpen()}>
      Cookie voorkeuren instellen
    </Link>{' '}
    -{' '}
    <a href="https://thuisleefgroep.nl/cookiebeleid/" className="underline" target="_blank" rel="noopener noreferrer">
      Cookie beleid
    </a>
  </div>
);

export default BottomBar;
